let log;
let warn;
let error;
let disabled = false;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let _window;
const disableCommonConsoleOutput = () => {
    log = _window.console.log;
    warn = _window.console.warn;
    error = _window.console.error;
    _window.console.log = () => undefined;
    _window.console.warn = () => undefined;
    _window.console.error = () => undefined;
    // use console.debug or console.info instead
    disabled = true;
};
const enableCommonConsoleOutput = () => {
    if (disabled) {
        _window.console.log = log;
        _window.console.warn = warn;
        _window.console.error = error;
        disabled = false;
    }
};
const canRun = () => {
    // If a variable is not defined, then typeof will return 'undefined'.
    // It will also return 'undefined' if the variable is set to undefined.
    // In either case, we do not want to suppress the console.
    // Ex:
    // const un = undefined
    // typeof un -> is 'undefined'
    // typeof variableNeverDefined -> is 'undefined'
    const beforeAllDefined = !(typeof beforeAll === 'undefined');
    const afterAllDefined = !(typeof afterAll === 'undefined');
    const windowDefined = !(typeof window === 'undefined');
    return beforeAllDefined && afterAllDefined && windowDefined;
};
/**
 * suppresses console.log, warn and error. Restores to normal after tests.
 * (useful when imported modules spam the console with noisy logs).
 * Use debug or info if you want to see your logs.
 */
export const suppressConsole = () => {
    if (canRun()) {
        _window = window;
        beforeAll(() => {
            disableCommonConsoleOutput();
        });
        afterAll(() => {
            enableCommonConsoleOutput();
        });
    }
    else {
        console.warn("Trying to run unit test utility function suppressConsole but it doesn't seem we are in a unit test environment! Not suppressing!");
    }
};
//# sourceMappingURL=UnitTestUtils.js.map